
import { useToast as useToastOriginal, toast as toastOriginal } from "@/hooks/use-toast";

// Extended toast with additional methods
const toast = {
  ...toastOriginal,
  
  // Success toast with predefined styling
  success: (message: string, description?: string) => {
    return toastOriginal({
      title: message,
      description,
      variant: "default",
      duration: 3000
    });
  },
  
  // Error toast with predefined styling
  error: (message: string, description?: string) => {
    return toastOriginal({
      title: message,
      description,
      variant: "destructive",
      duration: 5000,
    });
  },
  
  // Info toast with predefined styling
  info: (message: string, description?: string) => {
    return toastOriginal({
      title: message,
      description,
      variant: "default",
      duration: 4000,
    });
  },
};

// Re-export the hook
export { useToastOriginal as useToast, toast };
